<template>
 <div class="pageFooter">
   <div class="pageFooter__content">
     <div class="pageFooter__linkArr">
        <span class="iconBox"><img class="iconBox__img" src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/6cf5b8e6-cd52-4ac3-a7fd-6ddad8af1bee.png"></span>
        <span class="pageFooter__linkArr__content">400-0033-166</span>
     </div>
    <div class="pageFooter__qrcode">
      <p class="pageFooter__qrcode__item">
          <img :src="wxImg">
          <span>关注推小宝公众号</span>
      </p>
      <p class="pageFooter__qrcode__item">
          <img :src="xcxImg">
          <span>微信扫码体验小程序</span>
      </p>
    </div>
  <p class="pageFooter__tel">联系地址:&nbsp;&nbsp;成都市高新区蜀锦路88号新中泰国际大厦A座15楼</p>
  <p class="pageFooter__copyright">Copyright © 2004-2020 万商云集（成都）科技股份有限公司 版权所有蜀ICP备12001963号-2</p>
   </div>
 </div>
</template>
<script>
import wxImg from '@assets/images/web/wx.png'
import xcxImg from '@assets/images/web/xcx.png'
export default {
  name:'PFooter',
  data(){
    return {
      wxImg,
      xcxImg
    }
  }
}
</script>
<style lang="scss" scoped>
@include b(pageFooter){
  width:90%;
  background-color: $color-primary;
  overflow: hidden;
  position: relative;
  padding:60px 5%;
  @include e(content){
    color:$color-white;
    width:100%;
  }

  @include e(linkArr){
    height: 92px;
    width:100%;
    border: 1Px solid $border-color-primary;
    border-radius: 46px;
    font-size: 21Px;
    text-align: center;
    line-height: 92px;
    position: relative;
    .iconBox{
       @include center-translate(vertical)
    }
    @include e(content){
      padding-left:65px;
    }
  }
  @include e(qrcode){
    display: flex;
    justify-content: space-between;
    width:566px;
    margin:37px auto;
    
    p{
      line-height: 1;
      margin:0;
      img{
        margin-bottom: 16px;
      }
      span{
        font-size: 22px;
        color:$color-text-tertiary;
        line-height: 1;
      }
    }
    @include e(item){
      width:250px;
      text-align:center;
    }
  }
  @include e(tel){
    font-size: 11Px;
    padding-bottom: 41px;
    border-bottom: 1px solid $border-color-primary;
    text-align: center;
    margin:40px auto;
  }
  @include e(copyright){
    font-size: 11Px;
    color:$color-text-tertiary;
    text-align: center;
    margin:0;
  }
}
</style>